import { profanities } from "profanities";

export function containsProfanities(w: string) {
    const words = w.toLowerCase().split(/[^a-z0-9]+/);

    for (const word of words) {
        if (profanities.includes(word)) {
            return true
        }
    }
    return false;
}